import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from './components/frontend/layout/Layout'
import AdminLayout from './components/admin/layout/AdminLayout'
import EmbeddableMapVue from './components/frontend/embeddableMap/EmbeddableMap'
import EmbeddableIcodeMap from './components/frontend/embeddableMap/EmbeddableIcodeMap'
import { store } from './store/store'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('../src/components/frontend/home/Home.vue')
      },
      {
        path: '/global-codes',
        name: 'GlobalCodes',
        component: () => import('./components/frontend/countrymap/worldMap')
      },
      {
        path: '/globalCodes',
        redirect: '/global-codes'
      },
      {
        path: '/code-adoption-map/:icode?',
        name: 'ICodeMap',
        component: () => import('../src/components/frontend/icodemap/ICodeMap')
      },
      {
        path: 'country/united-states-of-america',
        redirect: '/'
      },
      {
        path: 'country/usa',
        redirect: '/'
      },
      {
        path: 'country/:countryName?',
        name: 'WorldCodeAdoption',
        component: () =>
          import('../src/components/frontend/worldcodeadoption/WorldCodeAdoption.vue')
      },
      {
        path: 'country/:countryName?/state/:stateName?',
        name: 'StateCodeAdoption',
        component: () => import('../src/components/frontend/codeadoption/CodeAdoption.vue')
      },
      {
        path: 'state/:stateName?',
        redirect: to => {
          const { params } = to
          return 'country/usa/state/' + params.stateName.toLowerCase()
        }
      },
      {
        path: 'country/:countryName?/state/:stateName?/county/:countyName?',
        name: 'CountyCodeAdoption',
        component: () => import('../src/components/frontend/codeadoption/CodeAdoption.vue')
      },
      {
        path: 'state/:stateName?/county/:countyName?',
        redirect: to => {
          const { params } = to
          return 'country/usa/state/' + params.stateName.toLowerCase() + '/county/' + params.countyName.toLowerCase()
        }
      },
      {
        path: 'country/:countryName?/state/:stateName?/jurisdiction/:jurisdictionName?',
        name: 'JurisdictionCodeAdoption',
        component: () => import('../src/components/frontend/codeadoption/CodeAdoption.vue')
      },
      {
        path: 'state/:stateName?/jurisdiction/:jurisdictionName?',
        redirect: to => {
          const { params } = to
          return 'country/usa/state/' + params.stateName.toLowerCase() + '/jurisdiction/' + params.jurisdictionName.toLowerCase()
        }
      },
      {
        path: 'country/:countryName?/state/:stateName?/county/:countyName?/township/:townshipName?',
        name: 'TownshipCodeAdoption',
        component: () => import('../src/components/frontend/codeadoption/CodeAdoption.vue')
      },
      {
        path: 'state/:stateName?/county/:countyName?/township/:townshipName?',
        redirect: to => {
          const { params } = to
          return 'country/usa/state/' + params.stateName.toLowerCase() + '/county/' + params.countyName.toLowerCase() + '/township/' + params.townshipName.toLowerCase()
        }
      }]
  },
  {
    path: '/embeded-map',
    component: EmbeddableMapVue,
    name: 'EmbeddableMapVue'
  },
  {
    path: '/embeded-icode-map/:icode?',
    component: EmbeddableIcodeMap,
    name: 'EmbeddableIcodeMap'
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [{
      path: 'login',
      name: 'AdminLogin',
      component: () => import('../src/components/admin/login/AdminLogin.vue')
    },
    {
      path: 'dashboard',
      name: 'AdminDashboard',
      component: () => import('../src/components/admin/dashboard/AdminDashboard.vue')
    },
    {
      path: 'adoptions',
      name: 'AdminAdoptions',
      component: () => import('../src/components/admin/adoptions/manageadoptions/ManageAdoption.vue')
    },
    {
      path: 'adoptions/edit/:id?',
      name: 'EditAdminAdoptions',
      component: () => import('../src/components/admin/adoptions/manageadoptions/ManageEditAdoption.vue')
    },
    {
      path: 'codebooks',
      name: 'AdminCodebook',
      component: () => import('../src/components/admin/codebooks/managecodebooks/ManageCodeBook.vue')
    },
    {
      path: 'codeyears',
      name: 'AdminCodeyears',
      component: () => import('../src/components/admin/codebooks/managecodeyears/ManageCodeYear.vue')
    },
    {
      path: 'code-book-import',
      name: 'AdminCodebookImport',
      component: () => import('../src/components/admin/codebooks/uploadcodebooks/UploadCodebooks.vue')
    },
    {
      path: 'jurisdictions',
      name: 'AdminJurisdictions',
      component: () => import('../src/components/admin/locations/managejurisdictions/ManageJurisdiction.vue')
    },
    {
      path: 'townships',
      name: 'AdminTownships',
      component: () => import('../src/components/admin/locations/managetownships/ManageTownship.vue')
    },
    {
      path: 'counties',
      name: 'AdminCounties',
      component: () => import('./components/admin/locations/managecounties/ManageCounty.vue')
    },
    {
      path: 'states',
      name: 'AdminStates',
      component: () => import('./components/admin/locations/managestates/ManageState.vue')
    },
    {
      path: 'countries',
      name: 'AdminCountries',
      component: () => import('./components/admin/locations/managecountries/ManageCountry.vue')
    },
    {
      path: 'users',
      name: 'AdminUsers',
      component: () => import('../src/components/admin/users/manageusers/ManageUser.vue')
    },
    {
      path: 'iso-adoptions-import',
      name: 'AdminAdoptionImport',
      component: () => import('../src/components/admin/adoptions/uploadAdoptionData/UploadAdoption.vue')
    },
    {
      path: 'adoptions-import',
      name: 'AdminAdoptionInformationImport',
      component: () => import('../src/components/admin/adoptions/adoptioninformationimport/AdoptionInformationImport.vue')
    },
    {
      path: 'publishers',
      name: 'AdminPublishers',
      component: () =>
        import(
          '../src/components/admin/codebooks/managepublishers/ManagePublisher.vue'
        )
    },
    {
      path: 'adoptionprofiles',
      name: 'AdoptionProfiles',
      component: () =>
        import(
          '../src/components/admin/adoptions/manageadoptionprofiles/ManageAdoptionProfile.vue'
        )
    },
    {
      path: 'adoptionstatuses',
      name: 'AdoptionStatuses',
      component: () =>
        import(
          '../src/components/admin/adoptions/manageadoptionstatuses/ManageAdoptionStatus.vue'
        )
    },
    {
      path: 'adoptiontypes',
      name: 'AdoptionTypes',
      component: () =>
        import(
          '../src/components/admin/adoptions/manageadoptiontypes/ManageAdoptionType.vue'
        )
    },
    {
      path: 'adoptionlabels',
      name: 'AdoptionLabels',
      component: () =>
        import(
          '../src/components/admin/adoptions/manageadoptionlabels/ManageAdoptionLabel.vue'
        )
    },
    {
      path: 'postalcodes',
      name: 'PostalCodes',
      component: () =>
        import(
          '../src/components/admin/locations/managepostalcodes/ManagePostalCode.vue'
        )
    },
    {
      path: 'auditlogs',
      name: 'AdminAuditDataLogs',
      component: () =>
        import('../src/components/admin/data/auditlogs/AdminAuditDataLog.vue')
    },
    {
      path: 'usefullinks',
      name: 'AdminDataUsefulLinks',
      component: () =>
        import(
          '../src/components/admin/data/usefullinks/AdminDataUsefulLink.vue'
        )
    },
    {
      path: 'keycontacts',
      name: 'AdminDataKeyContacts',
      component: () =>
        import(
          '../src/components/admin/data/keycontacts/AdminDataKeyContact.vue'
        )
    },
    {
      path: 'forgotpassword',
      name: 'AdminForgotPassword',
      component: () =>
        import(
          '../src/components/admin/forgotpassword/AdminForgotPassword.vue'
        )
    },
    {
      path: 'resetpassword/:token?',
      name: 'AdminOuterResetPassword',
      component: () =>
        import(
          '../src/components/admin/forgotpassword/AdminOuterResetPassword.vue'
        )
    },
    {
      path: ':adoptionLevel/bulkadoption/:id',
      name: 'BulkAdoption',
      component: () =>
        import(
          '../src/components/admin/adoptions/managebulkadoptions/AddBulkAdoption.vue'
        )
    },
    {
      path: 'states/edit/:id/key/:tabId?',
      name: 'AdminEditState',
      component: () =>
        import(
          '../src/components/admin/locations/managestates/ManageEditState.vue'
        )
    },
    {
      path: 'countries/edit/:id/key/:tabId?',
      name: 'AdminEditCountry',
      component: () =>
        import(
          '../src/components/admin/locations/managecountries/ManageEditCountry.vue'
        )
    },
    {
      path: 'counties/edit/:id/key/:tabId?',
      name: 'AdminEditCounty',
      component: () =>
        import(
          '../src/components/admin/locations/managecounties/ManageEditCounty.vue'
        )
    },
    {
      path: 'jurisdictions/edit/:id/key/:tabId?',
      name: 'AdminEditJurisdiction',
      component: () =>
        import(
          '../src/components/admin/locations/managejurisdictions/ManageEditJurisdiction.vue'
        )
    },
    {
      path: 'locations-import',
      name: 'LocationEntityImport',
      component: () =>
        import(
          '../src/components/admin/locations/manageentityimports/LocationEntityImport.vue'
        )
    },
    {
      path: 'import-status',
      name: 'ImportStatus',
      component: () =>
        import(
          '../src/components/admin/reporting/ImportStatus/ImportStatus.vue'
        )
    },
    {
      path: 'proposed-adoptions',
      name: 'AdminProposedAdoptionList',
      component: () =>
        import(
          '../src/components/admin/reporting/manageproposedadoptions/ManageProposedAdoption.vue'
        )
    },
    {
      path: 'adoption-activity',
      name: 'AdminAdoptionActivityList',
      component: () =>
        import(
          '../src/components/admin/reporting/manageadoptionactivity/ManageAdoptionActivity.vue'
        )
    },
    {
      path: 'townships/edit/:id/key/:tabId?',
      name: 'AdminEditTownship',
      component: () =>
        import(
          '../src/components/admin/locations/managetownships/ManageEditTownship.vue'
        )
    },
    {
      path: 'icode-color',
      name: 'AdminICodeColor',
      component: () =>
        import(
          '../src/components/admin/codebooks/manageicodecolors/ManageICodeColor.vue'
        )
    }]
  },
  {
    // catch all 404 - define at the very end
    path: '*',
    component: Layout,
    children: [
      {
        path: '*',
        name: 'PageNotFound',
        component: () =>
          import('../src/components/pagenotfound/PageNotFound.vue')
      }
    ]
  }]
const router = new VueRouter({
  mode: 'history',
  base: '/adoptions/',
  routes
})

router.beforeEach((to, from, next) => {
  /**
   * The validation and route guard will only applicable if anyone browsing admin section
   */
  if (/admin/.test(to.path)) {
    let isUserLogin = store.getters['AuthModule/isLoggedIn']
    /**
     * admin is not login and page is not login page and page is not forgot password and page is not reset password
     */
    if (
      !isUserLogin &&
      to.path !== '/admin/login' &&
      to.path !== '/admin/forgotpassword' &&
      to.path !== '/admin/resetpassword/' &&
      to.path !== '/admin/resetpassword'
    ) {
      next('/admin/login')
    } else if (
      isUserLogin &&
      (to.path === '/admin/login' ||
        to.path === '/admin/forgotpassword' ||
        to.path === '/admin/resetpassword' ||
        to.path === '/admin/resetpassword/')
    ) {
      // admin tring to access login page after login
      next('/admin/dashboard')
    } else if (isUserLogin && (to.path === '/admin' || to.path === '/admin/')) {
      // If admin user is login and tring to access only admin of admin/ route
      next('/admin/dashboard')
    } else {
      next()
    }
  } else {
    // Frontend user route guard will goes here
    next()
  }
})

export default router
